import {
  DependencyList, EffectCallback, useEffect, useRef,
} from "react";

// https://gitlab.com/devallama/use-did-update-effect/-/blob/main/src/index.ts?ref_type=heads
const useDidUpdateEffect = (
  effect: EffectCallback,
  deps?: DependencyList | undefined,
): void => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      effect();
    } else {
      didMountRef.current = true;
    }
  }, deps);
};

export default useDidUpdateEffect;
